module.exports = __webpack_public_path__ + "static/img/5-yuan-icon.4400b6d4.png";